/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Split_ArmsInputs */

const en_us2_profile_editors_split_arms = /** @type {(inputs: Profile_Editors_Split_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arms & shoulders`)
};

const pt_br2_profile_editors_split_arms = /** @type {(inputs: Profile_Editors_Split_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braços e ombros`)
};

const es_419_profile_editors_split_arms = /** @type {(inputs: Profile_Editors_Split_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brazos y hombros`)
};

const pt_pt2_profile_editors_split_arms = /** @type {(inputs: Profile_Editors_Split_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braços e ombros`)
};

const fr_fr2_profile_editors_split_arms = /** @type {(inputs: Profile_Editors_Split_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bras et épaules`)
};

const de_de2_profile_editors_split_arms = /** @type {(inputs: Profile_Editors_Split_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arme & Schultern`)
};

const it_it2_profile_editors_split_arms = /** @type {(inputs: Profile_Editors_Split_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braccia e spalle`)
};

/**
* | output |
* | --- |
* | "Arms & shoulders" |
*
* @param {Profile_Editors_Split_ArmsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_arms = /** @type {((inputs?: Profile_Editors_Split_ArmsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_ArmsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_arms(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_arms(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_arms(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_arms(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_arms(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_arms(inputs)
	return en_us2_profile_editors_split_arms(inputs)
});
export { profile_editors_split_arms as "profile-editors.split_arms" }